import { render, staticRenderFns } from "./GalleryView.vue?vue&type=template&id=18f22bca&scoped=true&"
import script from "./GalleryView.vue?vue&type=script&lang=js&"
export * from "./GalleryView.vue?vue&type=script&lang=js&"
import style0 from "./GalleryView.vue?vue&type=style&index=0&id=18f22bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f22bca",
  null
  
)

export default component.exports